import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Pagination extends BaseElement {
  constructor() {
    super();
    this.elementType = ElementType.pagination;
  }

  pages: PaginationPage[] = [];
}

export class PaginationPage extends ClickElement {
  value: string = '';
  active: boolean = false;
  disabled: boolean = false;
}
